//hzhqrcode.js
import React from "react";
import md5 from "js-md5";
import Config from "../../../config/Config";
import Widget from "../../../widget/Widget";
import WidgetAjax from "../../../widget/WidgetAjax";
import WidgetModal from "../../../widget/WidgetModal";
import QRCode from 'qrcode.react';

let path = Config.getBasePath();
let application = Config.getApplication();
let classComponent = Config.getClassComponent()
React.Component.prototype.$md5 = md5;

class GZHbind extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            qrImg: undefined,//二维码
            qrCodeLose: false,//二维码蒙层
            qrLoading: false,
            tabSwitch: 1,//注册登录页面切换 1 登录 2注册
            ticket: undefined,//二维码信息ID
        };

        if (this.props.onRef) {
            this.props.onRef(this);
        }

    }

    componentDidMount() {
        Widget.loadClass();

    }

    /**
     * 获取二维码
     */
    getGzhQrcode = () => {
        const onGzhQrcode = async (res) => {
            if (res.status == 0) {
                this.setState({ ticket: res.result.result });
                const onQrcode = (reslut) => {
                    this.setState({ qrImg: reslut.result.result });
                    this.forState();
                }

                WidgetAjax.ajax({ url: path + "/weixin/qrcode", params: { ticket: res.result.result }, callback: onQrcode });
            }
        }
        WidgetAjax.ajax({ url: path + "/weixin/bind_ticket", params: { application }, callback: onGzhQrcode });
    }

    /**
     * 轮询二维码状态
     */
    forState = () => {
        let forIndex = 0;
        this.timer = setInterval(() => {
            this.gzhState();
            forIndex++;
            if (forIndex == 30) {
                this.setState({ qrCodeLose: true })
                clearInterval(this.timer);
            }
        }, 2000);
    }

    /**
     * 状态查询
     */
    gzhState = () => {
        const { ticket } = this.state;
        const onGzhLogin = async (res) => {
            if (res.status == 0) {

                if (res.result && res.result.openid) {
                    // await this.setState({ gzhOpenid: res.result.gzhOpenid, qrLoading: true });
                    clearInterval(this.timer);
                    this.modalRef.onClose();

                    if (this.props && this.props.onOk) {
                        this.props.onOk();
                    }
                    //   this.login(); //绑定接口
                }
            }
        }
        WidgetAjax.ajax({ url: path + "/weixin/bind", params: { ticket }, callback: onGzhLogin });
    }

    /**
     * 二维码刷新
     */
    refresh = async () => {
        await this.getGzhQrcode();
        this.setState({ qrCodeLose: false });
    }



    onClose = () => {

        if (this.timer) clearInterval(this.timer);


    }

    open = () => {

        this.getGzhQrcode();
        this.modalRef.open();
    }




    render() {
        let { qrImg, qrCodeLose, qrLoading } = this.state;
        let { title } = this.props;

        return (
            <div className="slg-login" component-data="loginVersions2 addpost" >
                <WidgetModal onRef={ref => this.modalRef = ref} options={{ modalType: "form", title: title ? title : "温馨提示", width: "800px" }} onClose={this.onClose} >
                    {/* 登录 */}
                    <div component-data={classComponent}>
                        <div className="sg-boxDivide  sg-line" >
                            <div className="loginQrCode">
                                <div className="QrCodeTooltips"> 打开微信扫一扫，关注公众号，绑定微信快捷登录，</div>
                                <div className="QrCodeTooltips" style={{ marginTop: "0" }}>您将获得岗位到期提醒、岗位资讯等相关增值服务</div>
                                <div className="QRCodeBox" style={{ marginTop: '40px', marginBottom: '40px' }} >
                                    {/* 二维码失效 */}
                                    <div className="sg-qr-expired-mask" style={{ display: qrCodeLose ? 'block' : 'none' }}>
                                        <img className="sg-qr-expired-icon" alt="#" src={require("../../../img/qr-error.png")} />
                                        <div className="sg-qr-expired-message">二维码已失效</div>
                                        <a className="sg-qr-refresh" onClick={() => { this.refresh() }}>点击刷新</a>
                                    </div>
                                    {
                                        qrImg ?
                                            <img className={qrLoading ? "qrfuzzy" : ""} style={{ width: '211px', height: '211px' }} src={`data:image/png;base64, ${qrImg}`} alt="登录二维码" />
                                            :
                                            <div className="qrfuzzy"><QRCode value={'兰创鸿智人才服务平台'} size={180} /></div>
                                    }
                                </div>
                                {
                                    title ? <></> :
                                        <div className="sg-bottomNext" onClick={() => { this.modalRef.onClose(); this.onClose() }}>跳过</div>
                                }

                            </div>
                        </div>
                    </div>
                    {/* 登录end */}
                </WidgetModal>

            </div >
        );
    }
}

export default GZHbind;
